<script>
import Base from '@/plans/ZOOM_ROOMS/config/base';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';

export default {
  extends: Base,
  mixins: [audioUsCaMixin],
  data() {
    return {
      showCycleAlert: true,
    }
  },
  computed: {
    licenseAlertDesc() {
      return this.mx_defLicenseAlertDesc;
    }
  },
};
</script>
